import variables from '../../../styles/variables.module.scss';

export const CurrenciesShortHand: Record<string, string> = {
  RUB: '₽',
  USD: '$',
  KZT: '₸',
  EUR: '€',
  MXN: '¢',
  UAH: '₴',
};

export const CurrenciesName: Record<string, string> = {
  RUB: 'Rouble',
  USD: 'Dollar',
  KZT: 'Tenge',
  EUR: 'Euro',
  MXN: 'Pesso',
  UAH: 'Hryvnia'
};

export const CurrenciesColor: Record<string, string> = {
  RUB: variables.Color_Blue500,
  USD: variables.Color_Green500,
  KZT: variables.Color_Yellow500,
  EUR: variables.Color_Violette500,
  MXN: variables.Color_DarkGreen500,
  UAH: variables.Color_Pink500,
}

export const DEFAULT_COLOR = '#ccc';